import React from 'react'
import { CustomerInlineInput } from './CustomerInlineInput'

export const ProfileNameEdit = ({ ...rest }) => {
  return (
    <CustomerInlineInput
      name="profile.name"
      query={'profile { _id  name }'}
      displayContent={(e) => <h1 className="m-0">{e}</h1>}
      {...rest}
    />
  )
}
